import { Button, Card } from '@zenid/web';
import { genericError } from '../../../../styled-system/recipes';

function reloadPage() {
  window.location.reload();
}

export function GenericError() {
  const { contentsLayout, contentsInnerLayout, iconLayout, icon, title, messageLayout, message, actionsLayout } =
    genericError();
  return (
    <Card className={contentsLayout}>
      <div className={contentsInnerLayout}>
        <div className={iconLayout}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_meal.png`}
            className={icon}
            alt="エラーページのアイコン"
          />
        </div>
        <div className={messageLayout}>
          <h1 className={title}>エラーが発生しました</h1>
          <p className={message}>通信環境をご確認の上、少し時間を置いて再度お試しください。</p>
        </div>
        <div className={actionsLayout}>
          <Button color="primary" size="l" width={200} onClick={reloadPage}>
            再読み込み
          </Button>
        </div>
      </div>
    </Card>
  );
}
